export default "__VITE_ASSET__DXhdSIRu__"